import React from "react";
import { Card, Typography, Space, Tag, Button, Progress, Row, Col } from "antd";
import { useHistory } from "react-router-dom";
import { DashboardEndpoints } from "@DASHBOARD";
import { useGET } from "@API2";
import CountUp from "react-countup";
const { Title, Text } = Typography;

const DebtDashboardCard = () => {
  const history = useHistory();
  const { data: invoiceData } = useGET(DashboardEndpoints.getInvoiceDashboard);

  const goToOverdueInvoices = () => {
    history.push("/invoices/invoice?invoiceType=overdue");
  };

  return (
    <Card
      style={{
        borderRadius: 16,
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        overflow: "hidden",
        border: "2px solid #f0f0f0 !important",
      }}
      bodyStyle={{ padding: "16px 24px" }}
    >
      <Title
        level={4}
        style={{
          margin: 0,
          fontWeight: 600,
          marginBottom: 16,
          textAlign: "center",
        }}
      >
        Ödenmemiş Toplam Fatura Tutarı
      </Title>

      <Row gutter={16} align="middle">
        <Col span={24} style={{ textAlign: "center" }}>
          <div
            className="responsive-progress-container"
            style={{ cursor: "pointer" }}
            onClick={() => history.push("/invoices/invoice")}
          >
            <Progress
              className="custom-debt-progress"
              type="circle"
              percent={100}
              strokeColor="#ff6000"
              strokeWidth={7}
              width={265}
              format={() => (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Text
                    style={{ fontSize: 16, color: "#8C8C8C", marginBottom: 16 }}
                  >
                    Güncel Borç
                  </Text>
                  <h2
                    style={{
                      fontSize: 32,
                      fontWeight: 700,
                      color: "#262626",
                      lineHeight: "44px",
                    }}
                  >
                    <CountUp
                      end={invoiceData?.totalDebt || 0}
                      duration={0.75}
                      decimals={2}
                      formattingFn={(value) => {
                        const formatted = new Intl.NumberFormat("tr-TR", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(value);

                        return `${formatted} ₺`;
                      }}
                    />
                  </h2>
                </div>
              )}
            />
          </div>
        </Col>

        <Col span={24}>
          <Space
            direction="vertical"
            size={24}
            style={{ width: "100%", marginTop: 24 }}
          >
            <Card
              className="dashboard-hover-card"
              style={{
                borderRadius: 12,
                backgroundColor: "#FFF",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                cursor: "pointer",
              }}
              bodyStyle={{ padding: 24 }}
              onClick={goToOverdueInvoices}
            >
              <Space direction="vertical" size={12}>
                <Tag
                  color="purple"
                  style={{ borderRadius: 4, padding: "2px 8px", fontSize: 13 }}
                >
                  Vadesi Geçmiş Toplam Fatura Tutarı
                </Tag>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <h2
                    style={{
                      margin: 0,
                      fontWeight: 600,
                      color: "#262626",
                    }}
                  >
                    <CountUp
                      end={invoiceData?.overdueInvoiceTotal || 0}
                      duration={0.75}
                      decimals={2}
                      formattingFn={(value) => {
                        const formatted = new Intl.NumberFormat("tr-TR", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(value);

                        return `${formatted} ₺`;
                      }}
                    />
                  </h2>
                </div>
              </Space>
            </Card>

            <Card
              className="dashboard-hover-card"
              style={{
                borderRadius: 12,
                backgroundColor: "#FFF",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                cursor: "pointer",
              }}
              bodyStyle={{ padding: 16 }}
              onClick={goToOverdueInvoices}
            >
              <Space direction="vertical" size={12}>
                <Tag
                  color="purple"
                  style={{ borderRadius: 4, padding: "2px 4px", fontSize: 13 }}
                >
                  Vadesi Geçmiş Toplam Fatura Adedi
                </Tag>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Title level={4} style={{ margin: 0, fontWeight: 600 }}>
                    <CountUp
                      end={invoiceData?.overdueInvoiceCount || 0}
                      duration={0.75}
                      decimals={0}
                      formattingFn={(value) =>
                        `${new Intl.NumberFormat("tr-TR").format(value)} Adet`
                      }
                    />
                  </Title>
                </div>
              </Space>
            </Card>
          </Space>
        </Col>
      </Row>

      <div
        style={{
          marginTop: 24,
          borderTop: "1px solid #F0F0F0",
          marginRight: -32,
          marginLeft: -32,
          marginBottom: -24,
        }}
      >
        <Button
          type="text"
          block
          onClick={() => history.push("/invoices/invoice")}
          style={{
            height: 82,
            fontSize: 16,
            fontWeight: 500,
            color: "#262626",
            borderRadius: 0,
          }}
        >
          Detayları görüntüle
        </Button>
      </div>
    </Card>
  );
};

export default React.memo(DebtDashboardCard);
